import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { Button } from '../../../../../../../components';
import { notify } from '../../../../../../../store/modules/notifications/actions';
import useStyles from '../styles';

type Props = {
  title: string;
  copyContent: string;
};

const CopyString = ({ title, copyContent }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const clickHandler = useCallback(() => {
    if (copyToClipboard(copyContent)) {
      dispatch(
        notify({
          type: 'info',
          icon: 'copy',
          message: `${title} copied.`,
        }),
      );
    } else {
      dispatch(
        notify({
          type: 'error',
          icon: 'copy',
          message: `${title} copying failed.`,
        }),
      );
    }
  }, [dispatch, copyContent, title]);

  if (copyContent) {
    return (
      <Button
        color="default"
        variant="text"
        className={classes.groupAction}
        onClick={clickHandler}
      >
        Copy
      </Button>
    );
  }

  return null;
};

export default CopyString;
